const validateName = (input: string): boolean => input.length > 0;

export default validateName;
